<template>
  <div class="news">
    <img class="loading" v-if="loading == true" src="@/assets/imgs/loading.png" alt="">
    <div v-loading="loading" class="newsBox" v-for="item in newData" :key="item.ID">
      <img class="titlePic" :src="item.coverPhotoLink" alt="">
      <ul>
        <li @click="clickNewsDetails(item.id)">{{ item.title }}</li>
        <li>{{ item.synopsis }}</li>
        <li>
          <p class="time">
            <span>{{ item.postTime }}</span>
          </p>
          <p>
            <span @click="clickNewsDetails(item.id)" style="cursor: pointer;">了解更多 ></span>
            <img src="@/assets/imgs/more.png" alt="">
          </p>
        </li>
      </ul>
    </div>
    <button @click="moreNews">
      <span>加载更多</span>
      <img src="@/assets/imgs/more.png" alt="">
    </button>
  </div>
</template>

<script>
import { postCmsSystemRelay } from '@/apis/transfer';

export default {
  name: 'news',
  data() {
    return {
      newData: [],
      // 接口参数

      attr: {
        type: "NEWS",
        groupCode: "",
        pageIndex: 1,
        pageRow: 5,
      },
      loading: true,
    }
  },
  created() {
    // 初始化数据
    this.init(this.attr, 0);
  },
  methods: {
    // 接口调用
    init(attr, key) {
      postCmsSystemRelay('hotNewsApi', attr).then(res => {
        
        if (key == 1) {
          this.newData = [...this.newData, ...res.lst]
        } else {
          this.newData = res.lst
          this.loading = false
        }
      })
        .catch(err => {
          console.log(err);
        })
    },
    // 获取更多新闻 
    moreNews() {
      if (this.attr.pageRow == 5) {
        this.attr.pageIndex = 1;
        this.attr.pageRow = 10;
        this.init(this.attr, 0);
      } else {
        this.attr.pageIndex++;
        this.init(this.attr, 1);
      }
    },
    // 跳转到新闻详情页
    clickNewsDetails(attr) {
      let routeData = this.$router.resolve({
        name: "newsDetails",
        query: {
          id: attr
        }
      });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>

<style lang="less" scoped>
.news {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .loading {
    margin: 0 auto 30px;
    width: 50px;
  }

  .newsBox {
    width: 100%;
    height: 180px;
    box-sizing: border-box;
    // padding: 50px 0;
    margin-bottom: 50px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    // border-bottom: 1px solid #c2c2c2;
    background: #ffffff;

    .titlePic {
      width: 396px;
      height: 180px;
      object-fit: cover;
      // margin-right: 50px;
    }

    ul {
      width: 72.5%;
      height: 90%;
      display: flex;
      padding: 0 26px;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: flex-start;
      margin: 0;

      li {
        width: 100%;

        p {
          display: flex;
          justify-content: center;
          align-items: center;

          // margin-left: 20px;
          img {
            margin-right: 8px;
          }
        }
      }

      li:nth-child(1) {
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        color: #0F0F11;

        cursor: pointer;
      }

      li:nth-child(2) {
        color: #666666;
        line-height: 26px;
      }

      li:nth-child(3) {
        .time {
          display: block;
        }

        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #93939F;
        font-size: 14px;
        line-height: 18px;
      }
    }
  }

  button {
    width: 195px;
    height: 60px;
    border-radius: 5px;
    background-color: #FAFAFA;
    border: none;
    margin: 72px auto 110px;
    cursor: pointer;

    span {

      cursor: pointer;
      color: #FA2314;
      text-decoration: underline;
      margin-right: 5px;
    }

    img {
      width: 10px;
      height: auto;
    }
  }
}

@media screen and (max-width: 500px) {
  .news {
    width: 92%;
    margin: 0 auto;

    .loading {
      margin: 0 auto 30px;
      width: 30px;
    }

    .newsBox {
      width: 100%;
      height: auto;
      box-sizing: border-box;
      padding: 20px 0;
      display: flex;
      // flex-direction: column;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #c2c2c2;

      .titlePic {
        width: 151px;
        // width: 154px;
        height: 108px;
        margin-right: 0px;
        border-radius: 5px;
        object-fit: cover;
      }

      ul {
        width: 90%;
        margin: 0 auto;
        box-sizing: border-box;
        padding-top: 15px;

        li:nth-child(1) {
          font-size: 14px;
          font-weight: 600;
          display: -webkit-box;
          /* 必须使用这个属性来支持多行省略号 */
          -webkit-box-orient: vertical;
          /* 必须设置为纵向排列 */
          -webkit-line-clamp: 1;
          /* 限制显示最多两行 */
          overflow: hidden;
          /* 超出部分隐藏 */
          text-overflow: ellipsis;
          /* 超出部分显示省略号 */
        }

        li:nth-child(2) {
          font-size: 12px;
          line-height: 16px;
          margin: 10px auto 5px;
          display: -webkit-box;
          /* 必须使用这个属性来支持多行省略号 */
          -webkit-box-orient: vertical;
          /* 必须设置为纵向排列 */
          -webkit-line-clamp: 1;
          /* 限制显示最多两行 */
          overflow: hidden;
          /* 超出部分隐藏 */
          text-overflow: ellipsis;
          /* 超出部分显示省略号 */
        }

        li:nth-child(3) {
          .time {
            display: none;
          }

          justify-content: flex-end;

          p {
            margin-left: 10px;

            span {
              font-size: 12px;
            }

            img {
              width: 18px;
              height: auto;
              margin-right: 3px;
            }
          }
        }
      }
    }

    button {
      width: 125px;
      height: 40px;
      border-radius: 5px;
      background-color: #FAFAFA;
      border: none;
      cursor: pointer;

      margin: 20px 0;
      font-size: 14px;
    }
  }
}
</style>
